import { render } from "./InputTextGroup.vue?vue&type=template&id=37bcf822&ts=true"
import script from "./InputTextGroup.vue?vue&type=script&lang=ts"
export * from "./InputTextGroup.vue?vue&type=script&lang=ts"

import "./InputTextGroup.vue?vue&type=style&index=0&id=37bcf822&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__